// extracted by mini-css-extract-plugin
export default {"container":"UpcomingWorkspaces_container__LJEQF","listItem":"UpcomingWorkspaces_listItem__xm09u"};